import { styled } from '@material-ui/core';

import { down } from '../../../assets/style/breakpointHelpers';
import { domTag } from '../styledFilter';

export const FormControlContainer = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	textAlign: 'left',
	alignItems: 'flex-start',
});

// Wrapper for input with prefix
export const InputWithPrefixWrapper = styled(domTag('div', ['iserror', 'isvalid']))(({
	iserror,
	isvalid,
}: {
	iserror?: string;
	isvalid?: boolean;
}) => {
	const getBorderColor = () => {
		if (iserror) return 'var(--color-error)';
		if (isvalid) return 'var(--color-success)';
		return 'var(--color-border-default)';
	};

	return {
		'display': 'flex',
		'alignItems': 'stretch',
		'width': '100%',
		'maxWidth': 320,
		'borderRadius': 'var(--radius-default)',
		'border': `1px solid ${getBorderColor()}`,
		'backgroundColor': 'var(--color-bg-primary)',
		'transition':
			'border-color var(--transition-fast), box-shadow var(--transition-fast), background-color var(--transition-fast)',
		'overflow': 'hidden',
		'&:hover:not(:focus-within)': {
			borderColor: iserror ? 'var(--color-error)' : isvalid ? 'var(--color-success)' : 'var(--color-border-strong)',
		},
		'&:focus-within': {
			borderColor: iserror ? 'var(--color-error)' : isvalid ? 'var(--color-success)' : 'var(--color-border-focus)',
			boxShadow: iserror
				? '0 0 0 3px var(--color-error-bg)'
				: isvalid
					? '0 0 0 3px color-mix(in srgb, var(--color-success) 20%, transparent)'
					: '0 0 0 3px color-mix(in srgb, var(--color-brand-primary) 20%, transparent)',
		},
		[down('md')]: {
			minWidth: 280,
		},
	};
});

// Prefix box containing icon and @ symbol
export const InputPrefix = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '4px',
	padding: '0 12px',
	backgroundColor: 'var(--color-bg-secondary)',
	borderRight: '1px solid var(--color-border-default)',
	color: 'var(--color-text-secondary)',
	fontFamily: 'var(--font-family-regular)',
	fontSize: 'var(--text-body-size)',
	flexShrink: 0,
	userSelect: 'none',
});

// Input styled for use within prefix wrapper (no border of its own)
export const TextInputWithPrefix = styled('input')({
	'flex': 1,
	'fontFamily': 'var(--font-family-regular)',
	'fontSize': 'var(--text-body-size)',
	'outline': 'none',
	'border': 'none',
	'height': 40,
	'paddingLeft': 10,
	'backgroundColor': 'transparent',
	'color': 'var(--color-text-primary)',
	'minWidth': 0,
	'&::placeholder': {
		color: 'var(--color-text-tertiary)',
	},
	'&:disabled': {
		backgroundColor: 'var(--color-bg-tertiary)',
		color: 'var(--color-text-disabled)',
		cursor: 'not-allowed',
	},
	[down('md')]: {
		height: 48,
	},
});

export const InputLabelComponent = styled('label')({
	fontFamily: 'var(--font-family-medium)',
	fontSize: 'var(--text-label-size)',
	lineHeight: 'var(--leading-normal)',
	color: 'var(--color-text-primary)',
	marginBottom: 10,
});

export const InputError = styled('p')({
	fontFamily: 'var(--font-family-regular)',
	fontSize: 'var(--text-caption-size)',
	lineHeight: 'var(--leading-normal)',
	color: 'var(--color-error)',
	margin: 0,
});

export const TextInput = styled(domTag('input', ['iserror', 'isvalid', 'customwidth']))(({
	iserror,
	isvalid,
	customwidth,
}: {
	iserror?: string;
	isvalid?: boolean;
	customwidth?: string | number;
}) => {
	const getBorderColor = () => {
		if (iserror) return 'var(--color-error)';
		if (isvalid) return 'var(--color-success)';
		return 'var(--color-border-default)';
	};

	return {
		'fontFamily': 'var(--font-family-regular)',
		'fontSize': 'var(--text-body-size)',
		'outline': 'none',
		'borderRadius': 'var(--radius-default)',
		'maxWidth': customwidth || 320,
		'width': '100%',
		'height': 40,
		'paddingLeft': 10,
		'backgroundColor': 'var(--color-bg-primary)',
		'color': 'var(--color-text-primary)',
		'border': `1px solid ${getBorderColor()}`,
		'transition':
			'border-color var(--transition-fast), box-shadow var(--transition-fast), background-color var(--transition-fast)',
		'&::placeholder': {
			color: 'var(--color-text-tertiary)',
		},
		'&:hover:not(:focus):not(:disabled)': {
			borderColor: iserror ? 'var(--color-error)' : isvalid ? 'var(--color-success)' : 'var(--color-border-strong)',
		},
		'&:focus': {
			borderColor: iserror ? 'var(--color-error)' : isvalid ? 'var(--color-success)' : 'var(--color-border-focus)',
			boxShadow: iserror
				? '0 0 0 3px var(--color-error-bg)'
				: isvalid
					? '0 0 0 3px color-mix(in srgb, var(--color-success) 20%, transparent)'
					: '0 0 0 3px color-mix(in srgb, var(--color-brand-primary) 20%, transparent)',
		},
		'&:disabled': {
			backgroundColor: 'var(--color-bg-tertiary)',
			color: 'var(--color-text-disabled)',
			cursor: 'not-allowed',
		},
		[down('md')]: {
			minWidth: 280,
			height: 48,
		},
	};
});
